/* AURORIQA „Different Sky“ 2.0 (převzato z „Zrcadla“ 1.0.4) – obchodní chování motivu (ES modul, bez závislostí, bez rAF smyček).
   Košík: Cart Ajax API (/cart/add.js, /cart/change.js) se sections=cart-drawer, panel košíku (past fokusu, Escape,
   návrat fokusu), chyba 422 → description, výběr velikosti (rádia, „Nejdřív vyber velikost."), stavy tlačítka,
   menu na telefonu, tabulka velikostí (dialog), „Nastavení cookies" (Shopify.customerPrivacy), honeypot drop listu.
   Bez JS vše funguje přes formuláře (/cart/add → /cart); rádia mají required. */

const R = window.AQ_ROUTES || {};
const T = window.AQ_T || {};
const SEKCE = 'cart-drawer';
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const naStranceKosiku = () => document.body.dataset.template === 'cart';

class ChybaKosiku extends Error {}

async function posli(url, data) {
  const telo = Object.assign({}, data, { sections: SEKCE, sections_url: window.location.pathname });
  const r = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(telo)
  });
  let json = {};
  try { json = await r.json(); } catch (e) { /* prázdná odpověď */ }
  if (!r.ok) throw new ChybaKosiku(json.description || json.message || T.error);
  return json;
}

/* ---------- panel košíku ---------- */
const panel = () => $('[data-aq-drawer]');
const dialog = () => $('[data-aq-drawer-dialog]');
let zpet = null;

function otevri(odkud) {
  const p = panel();
  if (!p) return false;
  if (p.hidden) zpet = odkud || document.activeElement;
  p.hidden = false;
  document.documentElement.classList.add('aq-zamek');
  p.classList.add('is-open');
  const d = dialog();
  if (d) d.focus();
  return true;
}

function zavri() {
  const p = panel();
  if (!p || p.hidden) return;
  p.classList.remove('is-open');
  p.hidden = true;
  document.documentElement.classList.remove('aq-zamek');
  if (zpet && typeof zpet.focus === 'function' && document.contains(zpet)) zpet.focus();
  zpet = null;
}

function pocet(n, popisek) {
  $$('[data-aq-count]').forEach((e) => { e.textContent = n; e.hidden = false; });
  if (popisek) {
    $$('[data-aq-cart-link]').forEach((a) => a.setAttribute('aria-label', popisek));
    const live = $('[data-aq-live]');
    if (live) live.textContent = popisek;
  }
}

function vymen(sections, fokus) {
  const html = sections && sections[SEKCE];
  if (!html) { window.location.href = R.cart || '/cart'; return false; }
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const nove = $('[data-aq-drawer-body]', doc);
  const stare = $('[data-aq-drawer-body]');
  if (!nove || !stare) { window.location.href = R.cart || '/cart'; return false; }
  stare.replaceWith(nove);
  pocet(Number(nove.dataset.aqItemCount || 0), nove.dataset.aqCountLabel);
  const cil = fokus && $(`[data-aq-focus="${CSS.escape(fokus)}"]`, nove);
  if (cil) cil.focus(); else if (fokus && dialog()) dialog().focus();
  return true;
}

function chybaPanelu(text) {
  const e = $('[data-aq-drawer-chyba]');
  if (e) e.textContent = text || '';
}

async function zmenRadek(tlacitko) {
  const line = Number(tlacitko.dataset.line);
  const quantity = Math.max(0, Number(tlacitko.dataset.qty));
  tlacitko.setAttribute('aria-busy', 'true');
  tlacitko.disabled = true;
  try {
    const odp = await posli(`${R.cart_change}.js`, { line, quantity });
    if (naStranceKosiku()) { window.location.reload(); return; }
    vymen(odp.sections, quantity > 0 ? tlacitko.dataset.aqFocus : '__dialog');
  } catch (err) {
    tlacitko.removeAttribute('aria-busy');
    tlacitko.disabled = false;
    chybaPanelu(err instanceof ChybaKosiku ? err.message : T.error);
  }
}

/* ---------- přidání do košíku (stránka kusu, mozaika, kolekce) ---------- */
const nbsp = (t) => String(t || '').replace(/ /g, ' ');
const textTl = (tl, t) => { const s = tl && ($('[data-tl-text]', tl) || tl); if (s && t) s.textContent = t; };

function chybaFormulare(form, text) {
  const e = $('[data-aq-chyba]', form);
  if (e) e.textContent = text || '';
  const fs = $('[data-aq-velikost]', form);
  if (fs) { if (text) fs.setAttribute('aria-invalid', 'true'); else fs.removeAttribute('aria-invalid'); }
}

function okFormulare(form, text) {
  const e = $('[data-aq-ok]', form);
  if (e) e.textContent = text || '';
}

async function pridej(form, submitter) {
  const fd = new FormData(form);
  const id = Number(fd.get('id'));
  okFormulare(form, '');
  if (!id) {
    chybaFormulare(form, T.choose_size_first);
    const prvni = $('[data-aq-velikost] input:not([disabled])', form);
    if (prvni) prvni.focus();
    return;
  }
  const quantity = Math.max(1, Number(fd.get('quantity') || 1));
  const tl = submitter || $('[type="submit"]', form);
  if (tl) { tl.setAttribute('aria-busy', 'true'); tl.disabled = true; textTl(tl, T.adding); }
  chybaFormulare(form, '');
  try {
    const odp = await posli(`${R.cart_add}.js`, { items: [{ id, quantity }] });
    if (naStranceKosiku()) { window.location.reload(); return; }
    okFormulare(form, T.added);
    if (vymen(odp.sections, null)) otevri(tl);
  } catch (err) {
    chybaFormulare(form, err instanceof ChybaKosiku ? err.message : T.error);
  } finally {
    if (tl) { tl.removeAttribute('aria-busy'); tl.disabled = false; textTl(tl, T.add); }
  }
}

/* ---------- výběr velikosti ---------- */
function zmenaVelikosti(input) {
  const form = input.form;
  const koren = input.closest('[data-aq-product]') || form;
  if (input.dataset.price) {
    const ceny = $$('[data-aq-price]', koren);
    if (form.id === 'aq-produkt-form') ceny.push(...$$('[data-aq-pruh] [data-aq-price]'));
    ceny.forEach((c) => { c.textContent = nbsp(input.dataset.price); });
  }
  const nazev = $('[data-aq-size-current]', form);
  if (nazev) nazev.textContent = input.dataset.title ? ': ' + input.dataset.title : '';
  textTl($('[data-aq-add]', form), T.add);
  chybaFormulare(form, '');
  okFormulare(form, '');
  if (form.hasAttribute('data-aq-url-sync')) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', input.value);
    window.history.replaceState({}, '', url.toString());
  }
}

/* S JS hlásí chybějící velikost motiv (role=alert), ne bublina prohlížeče; bez JS platí required. */
function bezBubliny() { $$('form[data-aq-form]').forEach((f) => { f.noValidate = true; }); }

/* ---------- menu na telefonu ---------- */
function menu(otevrit, vratFokus) {
  const tl = $('[data-aq-menu-tl]');
  if (!tl) return;
  tl.setAttribute('aria-expanded', String(otevrit));
  document.documentElement.classList.toggle('aq-menu-otevrene', otevrit);
  if (otevrit) { const a = $('[data-aq-menu] a'); if (a) a.focus(); } else if (vratFokus) tl.focus();
}

/* ---------- události (delegované: přežijí výměnu HTML i editor motivů) ---------- */
document.addEventListener('click', (e) => {
  const otevrit = e.target.closest('[data-aq-cart-open]');
  if (otevrit && !naStranceKosiku() && panel()) { e.preventDefault(); menu(false); otevri(otevrit); return; }
  if (e.target.closest('[data-aq-drawer-close]')) { e.preventDefault(); zavri(); return; }
  const qty = e.target.closest('[data-aq-qty]');
  if (qty) { e.preventDefault(); zmenRadek(qty); return; }
  const mt = e.target.closest('[data-aq-menu-tl]');
  if (mt) { menu(mt.getAttribute('aria-expanded') !== 'true', false); return; }
  if (e.target.closest('[data-aq-menu] a')) menu(false);
  const dlg = $('[data-aq-miry]');
  if (e.target.closest('[data-aq-miry-otevri]') && dlg && typeof dlg.showModal === 'function') { e.preventDefault(); dlg.showModal(); return; }
  if (e.target.closest('[data-aq-miry-zavri]') && dlg) { dlg.close(); return; }
  if (e.target.closest('[data-aq-cookies]')) {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.showPreferences === 'function') cp.showPreferences();
  }
});

document.addEventListener('submit', (e) => {
  const dl = e.target.closest('form[data-aq-droplist]');
  if (dl) { const med = $('[data-aq-med]', dl); if (med && med.value) e.preventDefault(); return; }
  const form = e.target.closest('form[data-aq-form]');
  if (!form) return;
  e.preventDefault();
  pridej(form, e.submitter);
});

document.addEventListener('change', (e) => {
  if (e.target.matches('[data-aq-velikost] input[type="radio"]')) zmenaVelikosti(e.target);
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && document.documentElement.classList.contains('aq-menu-otevrene')) { menu(false, true); return; }
  const p = panel();
  if (!p || p.hidden) return;
  if (e.key === 'Escape') { e.preventDefault(); zavri(); return; }
  if (e.key !== 'Tab') return;
  const d = dialog();
  const prvky = $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', d)
    .filter((x) => x.offsetParent !== null);
  if (!prvky.length) { e.preventDefault(); d.focus(); return; }
  const prvni = prvky[0];
  const posledni = prvky[prvky.length - 1];
  const kde = document.activeElement;
  if (e.shiftKey && (kde === prvni || kde === d || !d.contains(kde))) { e.preventDefault(); posledni.focus(); }
  else if (!e.shiftKey && (kde === posledni || !d.contains(kde))) { e.preventDefault(); prvni.focus(); }
});

/* „Nastavení cookies" jen když existuje API Shopify (Customer Privacy); může se načíst později než motiv. */
function cookies(pokus = 0) {
  const cp = window.Shopify && window.Shopify.customerPrivacy;
  if (cp && typeof cp.showPreferences === 'function') { $$('[data-aq-cookies]').forEach((b) => { b.hidden = false; }); return; }
  if (pokus < 10) setTimeout(() => cookies(pokus + 1), 500);
}

/* Přilepená nákupní lišta kusu (telefon): ukáže se, až hlavní tlačítko odjede nahoru z obrazovky. Bez JS je vidět pořád.
   Scroll místo IntersectionObserveru: rychlý skok přes celé okno (např. Home) observer nezachytí (MĚŘENO na snímku). */
function pruh() {
  const p = $('[data-aq-pruh]');
  const tl = $('#aq-produkt-form [data-aq-add]');
  if (!p || !tl) return;
  p.classList.add('kus-pruh--js');
  let ceka = false;
  const over = () => { ceka = false; p.classList.toggle('je-videt', tl.getBoundingClientRect().bottom < 0); };
  window.addEventListener('scroll', () => { if (!ceka) { ceka = true; requestAnimationFrame(over); } }, { passive: true });
  over();
}

bezBubliny();
cookies();
pruh();
document.addEventListener('shopify:section:load', () => { zavri(); bezBubliny(); });
window.AQ_SHOP = { otevri, zavri };
